import { __assign } from "tslib";
import React, { useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import RoundCheckbox from '../../../RoundCheckbox';
import ToggleButton from '../../../ToggleButton';
import LoadingIndicator from '../../../LoadingIndicator';
import { ArrowDownThin } from '../../../Icons/ArrowDown';
import { IconSize } from '../../../Icons/IconWrap';
import { BiEventType, BiDiv } from '../../../biLogger';
import { LiveNotificationType, } from '../../redux/types';
import noop from '../../../utils/noop';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import s from './LiveSettingsDropdown.scss';
var notificationTypeOptions = [
    LiveNotificationType.COMMENTS,
    LiveNotificationType.REPLIES,
    LiveNotificationType.MENTIONS,
    LiveNotificationType.ACTIVITY,
];
var LiveSettingsDropdown = function (_a) {
    var className = _a.className, settings = _a.settings, isLoading = _a.isLoading, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.onOpen, onOpen = _c === void 0 ? noop : _c, _d = _a.onClose, onClose = _d === void 0 ? noop : _d, fetchSettings = _a.fetchSettings, saveSettings = _a.saveSettings;
    var t = useTranslation().t;
    var enabled = settings ? settings.enabled : false;
    var allowedTypes = (settings && settings.types) || {};
    var menuRef = useRef(null);
    var toggleRef = useRef(null);
    var setToggleRef = useCallback(function (node) { return (toggleRef.current = node); }, []);
    useOnOutsideClick([menuRef, toggleRef], onClose);
    useEffect(function () {
        // Get settings from backend if we don't have them
        if (!settings && !isLoading) {
            fetchSettings();
        }
    }, [settings, isLoading, fetchSettings]);
    var toggleStatus = function () {
        // When toggling live notifications, set all type filters on or off depending on the case
        var updatedStatus = !enabled;
        var updatedTypes = notificationTypeOptions.reduce(function (types, name) {
            types[name] = updatedStatus;
            return types;
        }, {});
        saveSettings({
            enabled: updatedStatus,
            types: updatedTypes,
        });
    };
    var toggleNotificationType = function (type) { return function (checked) {
        var _a;
        var updatedTypes = __assign(__assign({}, allowedTypes), (_a = {}, _a[type] = checked, _a));
        saveSettings({
            enabled: enabled,
            types: updatedTypes,
        });
    }; };
    return (React.createElement("div", { className: classnames(s['root'], isOpen && s['open'], className) },
        React.createElement(BiDiv, { className: s['dropdown-btn'], onClick: function () { return (isOpen ? onClose() : onOpen()); }, innerRef: setToggleRef, biData: {
                evid: BiEventType.LIVE_NOTIFICATION_CLICK,
                is_selected: isOpen ? 0 : 1,
            } },
            React.createElement("span", { className: classnames(s['status-dot'], enabled && s['enabled']) }),
            t('siteHeader.notificationsMenu.live'),
            React.createElement(ArrowDownThin, { className: s['arrow-icon'], size: IconSize.SMALL })),
        React.createElement("div", { className: s['dropdown-menu'], ref: menuRef },
            React.createElement("div", { className: s['live-description'] }, t('siteHeader.notificationsMenu.liveDescription')),
            React.createElement(BiDiv, { className: s['status-toggle'], onClick: toggleStatus, biData: {
                    evid: BiEventType.LIVE_NOTIFICATION_TOGGLE,
                    is_selected: enabled ? 0 : 1,
                } },
                t('siteHeader.notificationsMenu.liveToggle'),
                React.createElement(ToggleButton, { value: enabled, onChange: noop /* the container does the actual toggling here */ })),
            React.createElement("div", { className: classnames(s['notification-type'], enabled && s['active']) },
                React.createElement("div", { className: s['notification-type-title'] }, t('siteHeader.notificationsMenu.show')),
                React.createElement("ul", { className: s['notification-type-list'] }, notificationTypeOptions.map(function (type) { return (React.createElement("li", { className: s['notification-type-filter'], key: "filter-" + type },
                    React.createElement(RoundCheckbox, { label: t("siteHeader.notificationsMenu.notificationType." + type), isChecked: allowedTypes[type], onChange: toggleNotificationType(type), biData: {
                            evid: BiEventType.LIVE_NOTIFICATION_ACTIVITY_OPTION,
                            is_selected: allowedTypes[type] ? 0 : 1,
                            notification_type: type,
                        }, labelOnRight: true }))); }))),
            isLoading && React.createElement(LoadingIndicator, { className: s['loader'] }))));
};
LiveSettingsDropdown.displayName = 'LiveSettingsDropdown';
export default LiveSettingsDropdown;
//# sourceMappingURL=LiveSettingsDropdown.js.map